import { createAsyncThunk } from "@reduxjs/toolkit";
import { client as axios } from "../../Utils/axiosClient";

export const getBatterySosByTrip = createAsyncThunk(
  "trips/getBatterySosByTrip",
  async ({ tripId, rentalId }, { rejectWithValue }) => {
    try {
      const url = rentalId
        ? `${process.env.REACT_APP_API_URL}/battery-sos/mobile/battery-sos/active?rentalId=${rentalId}`
        : `${process.env.REACT_APP_API_URL}/battery-sos/mobile/battery-sos/active?tripId=${tripId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const assignBatterySosAgent = createAsyncThunk(
  "trips/assignBatterySosAgent",
  async ({ id, hubId, agentId, assignedBatteryIds }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/battery-sos/sos-request/${id}/assign`,
        { hubId, agentId, assignedBatteryIds }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const rejectBatterySos = createAsyncThunk(
  "trips/rejectBatterySos",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/battery-sos/sos-request/${id}/reject`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getHubWiseBatteries = createAsyncThunk(
  "trips/getHubWiseBatteries",
  async ({ hubId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/hub-station/hub-wise-batteries?hubId=${hubId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
